import Camera from "icons/Camera"
import tw, { css, styled } from "twin.macro"

const GalleryButtonStyled = tw.button`
  flex items-center space-x-3.5
  cursor-pointer
`
const CameraBg = styled.div(() => [
  tw`
    grid place-items-center
    w-10 h-10 rounded-full
    bg-white bg-opacity-20
  
    md:w-16 md:h-16
  `,
  css`
    svg {
      ${tw`h-4.5 w-3.5 md:h-5.5 md:w-4.5`}
    }
  `,
])

const Text = tw.span`
  text-white text-base font-semibold leading-snug!
`

const GalleryButton = (props) => {
  return (
    <GalleryButtonStyled {...props}>
      <CameraBg>
        <Camera />
      </CameraBg>
      <Text>View gallery</Text>
    </GalleryButtonStyled>
  )
}

export default GalleryButton
